<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.claim_request.step2.step') }}</p>
        <h1 class="project-title">{{ Translator('soprasolar.claim_request.step2.title') }}</h1>
        <save />
      </div>
      <div class="project-content">
        <form @submit="onSubmit" ref="form" id="formComments" class="std-form">
          <div class="form-group">
            <div class="form-label-container">
              <label for="comments" class="control-label">
                {{ Translator('soprasolar.claim_request.step2.form.comments') }}
              </label>
            </div>
            <textarea id="comments" class="form-control" v-model="form.comments"></textarea>
          </div>
        </form>
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <button type="submit" class="button-flat" form="formComments" :disabled="isLoading">
          {{ Translator('soprasolar.claim_request.send') }}
          <i class="ic ic-arrow-right" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
        <button type="button" class="button-link" @click="onPrevious">
          <i class="ic ic-arrow-left"></i>
          {{ Translator('soprasolar.project.previous') }}
        </button>
      </div>
    </div>
    <p class="project-legend">* {{ Translator('soprasolar.claim_request.required_field') }}</p>
  </div>
</template>
<style scoped lang="scss">
  @import "~@/soprasolar-claim/assets/styles/import";
</style>
<script>
import Save from '@/soprasolar-claim/components/Save';
import FormControl from 'aw-front-helpers/classes/formControl';
import AppControlService from '@/soprasolar-claim/services/AppControl';

export default {
  name: 'step-2',
  components: {
    Save
  },

  data () {
    return {
      datas: AppControlService.datas,
      isLoading: false,
      form: {},
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {
    this._form = new FormControl(this.$refs.form);
    if(this.datas.step2) this.form = this.datas.step2;
  },

  methods: {
    onSubmit(pEvt) {
      pEvt.preventDefault();
      if(this.isLoading) return;
      if(this._form.isValidate) {
        this.isLoading = true;
        AppControlService.update('step2', { ...this.form }).then( () => {
          AppControlService.finish().then( () => {
            AppControlService.goToNextStep();
          }).catch(console.error).then(() => {
            this.isLoading = false;
          })
        }).catch((err) => {
          this.isLoading = false;
          console.error(err)
        })
      }
    },

    onPrevious() {
      AppControlService.goToPrevStep();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      if(this.datas.step2) this.form = this.datas.step2;
    }
  }
};
</script>